module.exports = __webpack_public_path__ + "static/media/sican.427ddcb2.png";